<template>
  <div class="white-list-container">
    <div class="list-header">
      <h3>白名单管理</h3>
      <p class="description">添加用户到白名单后，只有白名单内的用户可以购买此商品</p>
    </div>

    <div class="search-box">
      <el-input
        placeholder="请输入用户名或手机号搜索"
        v-model="searchQuery"
        class="search-input"
        clearable
        @clear="handleClear"
      >
        <el-button slot="append" icon="el-icon-search" @click="searchUsers"></el-button>
      </el-input>
      <el-button type="primary" @click="addUsersDialogVisible = true">添加用户</el-button>
    </div>

    <!-- 白名单用户列表 -->
    <div class="list-content">
      <el-table
        v-loading="loading"
        :data="whiteListUsers"
        border
        style="width: 100%"
      >
        <el-table-column prop="userId" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="nickname" label="用户名称">
          <template slot-scope="scope">
            <div class="user-info">
              <el-avatar :size="40" :src="scope.row.avatarUrl" v-if="scope.row.avatarUrl"></el-avatar>
              <el-avatar :size="40" icon="el-icon-user" v-else></el-avatar>
              <span class="user-name">{{ scope.row.nickname }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop="addTime" label="添加时间" width="180"></el-table-column>
        <el-table-column label="操作" width="60">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="removeFromWhiteList(scope.row)"
            >移除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 添加用户弹窗 -->
    <el-dialog
      title="添加白名单用户"
      :visible.sync="addUsersDialogVisible"
      width="60%">
      <div class="dialog-search-box">
        <el-input
          placeholder="请输入用户名或手机号搜索"
          v-model="dialogSearchQuery"
          class="search-input"
          clearable
        >
          <el-button slot="append" icon="el-icon-search" @click="searchDialogUsers"></el-button>
        </el-input>
      </div>

      <el-table
        v-loading="dialogLoading"
        :data="searchedUsers"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column prop="userId" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="nickname" label="用户名称">
          <template slot-scope="scope">
            <div class="user-info">
              <el-avatar :size="40" :src="scope.row.avatarUrl" v-if="scope.row.avatarUrl"></el-avatar>
              <el-avatar :size="40" icon="el-icon-user" v-else></el-avatar>
              <span class="user-name">{{ scope.row.nickname }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop="createTime" label="注册时间" width="180"></el-table-column>
      </el-table>

      <!-- 弹窗分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleDialogSizeChange"
          @current-change="handleDialogCurrentChange"
          :current-page="dialogCurrentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="dialogPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="dialogTotal">
        </el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addUsersDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addToWhiteList">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';

export default {
  name: 'WhiteList',
  props: {
    productId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      whiteListUsers: [],
      searchQuery: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,

      // 添加用户弹窗
      addUsersDialogVisible: false,
      dialogLoading: false,
      dialogSearchQuery: '',
      searchedUsers: [],
      selectedUsers: [],
      dialogCurrentPage: 1,
      dialogPageSize: 10,
      dialogTotal: 0
    };
  },
  created() {
    this.getWhiteListUsers();
  },
  methods: {
    // 获取白名单用户
    getWhiteListUsers() {
      this.loading = true;
      const params = {
        productId: this.productId,
        page: this.currentPage,
        pageSize: this.pageSize,
        searchQuery: this.searchQuery
      };

      // 这里应该调用实际的API
      PorductApi.getWhiteListUsers(params)
        .then(res => {
          this.whiteListUsers = res.data.list;
          this.total = res.data.total;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$message.error('获取白名单用户失败');
          // 模拟数据，实际开发中删除
          this.mockWhiteListData();
        });
    },

    // 搜索白名单用户
    searchUsers() {
      this.currentPage = 1;
      this.getWhiteListUsers();
    },

    // 清除搜索
    handleClear() {
      this.searchQuery = '';
      this.searchUsers();
    },

    // 分页大小变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.getWhiteListUsers();
    },

    // 页码变化
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getWhiteListUsers();
    },

    // 搜索弹窗用户
    searchDialogUsers() {
      this.dialogLoading = true;
      const params = {
        page: this.dialogCurrentPage,
        pageSize: this.dialogPageSize,
        searchQuery: this.dialogSearchQuery
      };

      // 这里应该调用实际的API
      PorductApi.searchUsers(params)
        .then(res => {
          this.searchedUsers = res.data.list;
          this.dialogTotal = res.data.total;
          this.dialogLoading = false;
        })
        .catch(error => {
          this.dialogLoading = false;
          this.$message.error('搜索用户失败');
          // 模拟数据，实际开发中删除
          this.mockSearchedUsers();
        });
    },

    // 弹窗分页大小变化
    handleDialogSizeChange(val) {
      this.dialogPageSize = val;
      this.searchDialogUsers();
    },

    // 弹窗页码变化
    handleDialogCurrentChange(val) {
      this.dialogCurrentPage = val;
      this.searchDialogUsers();
    },

    // 表格选择变化
    handleSelectionChange(val) {
      this.selectedUsers = val;
    },

    // 添加到白名单
    addToWhiteList() {
      if (this.selectedUsers.length === 0) {
        this.$message.warning('请选择要添加的用户');
        return;
      }

      const userIds = this.selectedUsers.map(user => user.userId);
      const params = {
        productId: this.productId,
        userIds: userIds
      };

      // 这里应该调用实际的API
      PorductApi.addToWhiteList(params)
        .then(res => {
          this.$message.success('添加成功');
          this.addUsersDialogVisible = false;
          this.getWhiteListUsers();
        })
        .catch(error => {
          this.$message.error('添加失败');
          // 模拟成功，实际开发中删除
          this.$message.success('添加成功');
          this.addUsersDialogVisible = false;
          this.getWhiteListUsers();
        });
    },

    // 从白名单移除
    removeFromWhiteList(user) {
      this.$confirm('确定将该用户从白名单中移除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          productId: this.productId,
          userId: user.userId
        };

        // 这里应该调用实际的API
        PorductApi.removeFromWhiteList(params)
          .then(res => {
            this.$message.success('移除成功');
            this.getWhiteListUsers();
          })
          .catch(error => {
            this.$message.error('移除失败');
            // 模拟成功，实际开发中删除
            this.$message.success('移除成功');
            this.getWhiteListUsers();
          });
      }).catch(() => {});
    },

    // 模拟白名单数据，实际开发中删除
    mockWhiteListData() {
      this.whiteListUsers = [
        {
          userId: 1001,
          nickname: '张三',
          avatarUrl: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
          mobile: '13800138001',
          addTime: '2023-05-20 10:30:45'
        },
        {
          userId: 1002,
          nickname: '李四',
          avatarUrl: '',
          mobile: '13800138002',
          addTime: '2023-05-21 14:22:33'
        }
      ];
      this.total = 2;
      this.loading = false;
    },

    // 模拟搜索用户数据，实际开发中删除
    mockSearchedUsers() {
      this.searchedUsers = [
        {
          userId: 1001,
          nickname: '张三',
          avatarUrl: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
          mobile: '13800138001',
          createTime: '2023-01-10 08:30:45'
        },
        {
          userId: 1002,
          nickname: '李四',
          avatarUrl: '',
          mobile: '13800138002',
          createTime: '2023-01-15 09:22:33'
        },
        {
          userId: 1003,
          nickname: '王五',
          avatarUrl: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
          mobile: '13800138003',
          createTime: '2023-02-05 16:40:12'
        }
      ];
      this.dialogTotal = 3;
      this.dialogLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.white-list-container {
  padding: 20px;

  .list-header {
    margin-bottom: 20px;

    h3 {
      font-size: 20px;
      margin: 0 0 10px 0;
      color: #303133;
      font-weight: 600;
      position: relative;
      padding-left: 12px;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 18px;
        background-color: #409EFF;
        border-radius: 2px;
      }
    }

    .description {
      color: #909399;
      font-size: 14px;
      margin: 0;
      padding-left: 12px;
    }
  }

  .search-box {
    display: flex;
    margin-bottom: 20px;
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;

    .search-input {
      width: 300px;
      margin-right: 15px;

      /deep/ .el-input__inner {
        border-radius: 20px;
      }
    }

    .el-button {
      border-radius: 20px;
    }
  }

  .list-content {
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 20px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
    }
  }

  .user-info {
    display: flex;
    align-items: center;

    .user-name {
      margin-left: 10px;
    }
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }

  .dialog-search-box {
    margin-bottom: 20px;

    .search-input {
      width: 300px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/WhiteList.vue